import { render } from "./SelectionManager.vue?vue&type=template&id=ade6fba6&scoped=true&ts=true"
import script from "./SelectionManager.vue?vue&type=script&lang=ts"
export * from "./SelectionManager.vue?vue&type=script&lang=ts"

import "./SelectionManager.vue?vue&type=style&index=0&id=ade6fba6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade6fba6"]])

export default __exports__